module.exports = __webpack_public_path__ + "media/react/marketing/pages/gre/plans/assets/checkmark_icon-83de8721ae0965671a079eb6c86f92cd.svg";